import { HEADERS } from '.';

export const RESEARCH_API = {
  getAllResearch: () => ({
    endPoint: '/api/v1/sci/all',
    headers: HEADERS.TOKEN_HEADER,
    method: 'GET',
  }),
  getResearchByProfileId: (id) => ({
    endPoint: `/api/v1/sci/${id}/researches`,
    headers: HEADERS.TOKEN_HEADER,
    method: 'GET',
  }),
  insertResearch: () => ({
    endPoint: '/api/v1/sci/create',
    headers: HEADERS.TOKEN_HEADER,
    method: 'POST',
  }),
  updateResearch: () => ({
    endPoint: '/api/v1/sci/update',
    headers: HEADERS.TOKEN_HEADER,
    method: 'PUT',
  }),
  deleteResearch: (id) => ({
    endPoint: `/api/v1/sci/delete/${id}`,
    headers: HEADERS.TOKEN_HEADER,
    method: 'DELETE',
  }),
  updateResearchAccepted: () => ({
    endPoint: '/api/v1/formSciResearch/updateScore_Accepted',
    headers: HEADERS.TOKEN_HEADER,
    method: 'PUT',
  }),
  // Nối 1 liên kết vào hồ sơ ngay khi Thêm - không cần bấm Lưu bản nháp.
  linkResearchToForm: () => ({
    endPoint: '/api/v1/formSciResearch/addOne',
    headers: HEADERS.TOKEN_HEADER,
    method: 'POST',
  }),
};

export const RESEARCH_TYPE = {
  GET_ALL_RESEARCH_LOADING: 'GET_ALL_RESEARCH_LOADING',
  GET_ALL_RESEARCH_SUCCESS: 'GET_ALL_RESEARCH_SUCCESS',
  GET_ALL_RESEARCH_FAILURE: 'GET_ALL_RESEARCH_FAILURE',

  GET_RESEARCH_BY_PROFILE_ID_LOADING: 'GET_RESEARCH_BY_PROFILE_ID_LOADING',
  GET_RESEARCH_BY_PROFILE_ID_SUCCESS: 'GET_RESEARCH_BY_PROFILE_ID_SUCCESS',
  GET_RESEARCH_BY_PROFILE_ID_FAILURE: 'GET_RESEARCH_BY_PROFILE_ID_FAILURE',

  INSERT_RESEARCH_LOADING: 'INSERT_RESEARCH_LOADING',
  INSERT_RESEARCH_SUCCESS: 'INSERT_RESEARCH_SUCCESS',
  INSERT_RESEARCH_FAILURE: 'INSERT_RESEARCH_FAILURE',

  UPDATE_RESEARCH_LOADING: 'UPDATE_RESEARCH_LOADING',
  UPDATE_RESEARCH_SUCCESS: 'UPDATE_RESEARCH_SUCCESS',
  UPDATE_RESEARCH_FAILURE: 'UPDATE_RESEARCH_FAILURE',

  DELETE_RESEARCH_LOADING: 'DELETE_RESEARCH_LOADING',
  DELETE_RESEARCH_SUCCESS: 'DELETE_RESEARCH_SUCCESS',
  DELETE_RESEARCH_FAILURE: 'DELETE_RESEARCH_FAILURE',

  UPDATE_RESEARCH_ACCEPTED_LOADING: 'UPDATE_RESEARCH_ACCEPTED_LOADING',
  UPDATE_RESEARCH_ACCEPTED_SUCCESS: 'UPDATE_RESEARCH_ACCEPTED_SUCCESS',
  UPDATE_RESEARCH_ACCEPTED_FAILURE: 'UPDATE_RESEARCH_ACCEPTED_FAILURE',
};

export const RESEARCH_CONSTANTS = {
  // QCV 2026 (bảng điểm mục 2): gộp "bài báo quốc tế" và "bài báo trong nước"
  // vào CHUNG 1 mục. Mục bài báo trong nước riêng đã được comment ở achievementEditors,
  // nên thêm option "Bài báo, tạp chí trong nước" vào ngay danh sách quốc tế (Q1/Q2).
  // Chỉ tính bài báo thuộc danh mục HĐ chức danh GSNN và Quỹ Nafosted.
  TYPE_OPTIONS: {
    INTERNATIONAL: [
      { key: 'q1', title: 'Bài báo khoa học trên tạp chí quốc tế Q1', value: 'q1' },
      { key: 'q2', title: 'Bài báo khoa học trên tạp chí quốc tế Q2', value: 'q2' },
      { key: 'q3', title: 'Bài báo khoa học trên tạp chí quốc tế Q3', value: 'q3' },
      { key: 'q4', title: 'Bài báo khoa học trên tạp chí quốc tế Q4', value: 'q4' },
      // Giá trị do tính năng tự điền từ DOI gán khi coreCollection=Scopus mà
      // không xác định được quartile - không có trong dropdown chọn tay, chỉ
      // giữ ở đây để tra cứu tên phân loại (thiếu sẽ hiện trắng dù DB có dữ liệu).
      { key: 'scopus', title: 'Q4/Scopus', value: 'scopus' },
    ],
    // (Giữ lại - không xóa) danh sách trong nước cũ, dùng cho việc tra cứu tên phân loại
    DOMESTIC: [
      { key: 'domestic', title: 'Bài báo, tạp chí trong nước', value: 'domestic' },
    ]
  },
  ROLE_OPTIONS: [
    { key: 'main', title: 'Tác giả chính (Tác giả đầu, tác giả liên hệ)', value: 'main' },
    { key: 'member', title: 'Đồng tác giả', value: 'member' },
  ],
  typeOptionsQTK: [{ key: 'q5', title: 'Q5', value: 'q5' }],
};
